module.exports = __webpack_public_path__ + "img/hm_block02_en.6a22b289.jpg";